import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function useScrollToTop({ disabled } = {}) {
  const { pathname } = useLocation();

  useEffect(() => {
    if (disabled) return;

    window.scrollTo(0, 0);
  }, [pathname]);
}
